import { SystemLanguage } from 'hooks/business/system/useSystem';
import { UpdateVoucherStatusBody } from 'services/api/conversation';

export const systemLanguageMap: Record<SystemLanguage, UpdateVoucherStatusBody['language']> = {
  'zh-CN': 'chinese',
  'en-US': 'english',
  id: 'english',
  th: 'english',
  tl: 'english',
  es: 'english',
  vi: 'english',
  pt: 'english',
};

export const sellerMemosSupportOfficialPlatforms: General.PlatformUpperCaseTunnel[] = [
  'SHOPEE',
  'LAZADA',
  'TIKTOK',
  'TIKTOK_US',
];

export const sellerMemosLimit = 200;

export const SIDE_WIDTH_CACHE_KEY = 'conversationSiderWidth';
export const SIDE_MAX_WIDTH = 600;
export const SIDE_MIN_WIDTH = 420;
